import React from 'react'
import axios from 'axios';
import { baseUrl } from '../../../assets/Animations';
import TeacherCalendarFamilySearch from './TeacherCalendarFamilySearch/TeacherCalendarFamilySearch';
import TeacherCalendarLessonDetails from './TeacherCalendarLessonDetails/TeacherCalendarLessonDetails';
import {
    convertStringToUTCString,
    findDuplicateCalendarEvent,
    getSchoolIANATimezone,
} from '../../../Calendar/calendarFunctions';

const NewTeacherCalendarEvent = ({event, setEvent, teachersFamilies, setAllEvents, socket}) => {
    const [step, setStep] = React.useState(1)
    const [loading, setLoading] = React.useState(false)
    const [saveError, setSaveError] = React.useState('')

    React.useEffect(() => {
        setSaveError('')
    }, [event?.id])

    const createCalendarEvent = async (event) => {
        setLoading(true)
        setSaveError('')
        const utcDateTimeEvent = {
            ...event,
            teacherName: String(event.teacherName || '').trim(),
            dateTime: convertStringToUTCString(
                event.dateTime,
                getSchoolIANATimezone(event.school)
            ),
        }
        try {
            const response = await axios.get(
                `${baseUrl}/calendar/teacher/${utcDateTimeEvent.teacherId}`
            )
            if (findDuplicateCalendarEvent(utcDateTimeEvent, response?.data)) {
                setSaveError(
                    "This exact lesson is already on your calendar. No duplicate was created."
                )
                setLoading(false)
                return
            }

            const res = await axios.post(`${baseUrl}/calendar`, {event: utcDateTimeEvent})
            setEvent(false)
            setLoading(false)
            socket.emit('createCalendarEvent', {emitter: res.data.teacherName, packet: res.data})
            setAllEvents(prev => ([...prev, res.data]))
        } catch (err) {
            console.log(err)
            setSaveError(
                err?.response?.data?.message
                || 'The event could not be saved. Please try again.'
            )
            setLoading(false)
        }
      }

    if(event) return (
        <div>
            {step === 1 && <TeacherCalendarFamilySearch teachersFamilies={teachersFamilies} setStep={setStep} event={event} setEvent={setEvent} loading={loading} />}
            {step === 2 && <TeacherCalendarLessonDetails setStep={setStep} event={event} setEvent={setEvent} createCalendarEvent={createCalendarEvent} setLoading={setLoading} loading={loading} saveError={saveError} />}
        </div>
    )
    else return null
}
export default NewTeacherCalendarEvent;
